import { useMemo } from 'react';
import AdminUserFormSectionNav from './AdminUserFormSectionNav';
import useAdminUserFormSectionNav from '../../hooks/useAdminUserFormSectionNav';

/**
 * Composes sticky section nav + scroll spy for Add/Edit admin user forms (SRP).
 */
export default function AdminUserFormFlowNav({
  isStudent,
  mode,
  enabled = true,
  additionalExpanded,
  onExpandAdditional,
}) {
  const nav = useAdminUserFormSectionNav({
    isStudent,
    mode,
    enabled,
    additionalExpanded,
    onExpandAdditional,
  });

  const show = useMemo(() => enabled && nav.sections.length > 1, [enabled, nav.sections.length]);
  if (!show) return null;

  return (
    <AdminUserFormSectionNav
      sections={nav.sections}
      activeId={nav.activeId}
      onSelect={nav.goTo}
      onPrev={nav.goPrev}
      onNext={nav.goNext}
      hasPrev={nav.hasPrev}
      hasNext={nav.hasNext}
    />
  );
}
